import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { OptionsListElement } from '../../../Blocks/components/common/StyledEditables';

const ThumbnailUrl = () =>
<OptionsListElement>
    <Icon name="image" color="white" size={24} />
  </OptionsListElement>;


export default ThumbnailUrl;